// Auto-generated by scripts/sync-products-data.mjs — do not edit manually
// Groups: 26, Products: 83

export const productsData = {
  banner: {
    image: "/images/product-banner.jpg",
    alt: "Products Portfolio"
  },
  breadcrumb: [
    {
      label: "HOME",
      href: "/"
    },
    {
      label: "PRODUCTS",
      href: "/products"
    }
  ],
  pageTitle: "PRODUCTS PORTFOLIO",
  intro: {
    title: "Our Products",
    description: "We manufacture intermediates for several API’s falling under a wide range of therapeutic categories. We also manufacture fine chemicals & Specialty chemicals. We are among the largest manufacturer of thiophene products in India and we have an extensive range of different thiophene compounds."
  },
  tabs: [
    {
      id: "intermediates",
      label: "Intermediates",
      groups: [
        {
          name: "Intermediate For Alfuzosin, Doxazosin, Prazosin, Terazosin",
          products: [
            {
              image: "/images/product/intermediate/cas-23680-84-4.png",
              name: "2-Chlro-4-amino-6, 7-dimethoxyquinazoline",
              casNo: "23680-84-4"
            }
          ]
        },
        {
          name: "Intermediate For Alogliptin",
          products: [
            {
              image: "/images/product/intermediate/cas-4318-56-3.png",
              name: "6-Chloro-3-methyluracil",
              casNo: "4318-56-3"
            }
          ]
        },
        {
          name: "Intermediate Amoxapine &amp; Loxapine",
          products: [
            {
              image: "/images/product/intermediate/1.png",
              name: "2-Chlorodibenzo[b,f][1,4]oxazepin-11(10H)-one",
              casNo: "3158-91-6"
            }
          ]
        },
        {
          name: "Intermediates for Apixaban",
          products: [
            {
              image: "/images/product/intermediate/2.png",
              name: "5,6-Dihydro-3-(4-morpholinyl)-1-(4-nitrophenyl)-2(1H)-pyridinone",
              casNo: "503615-03-0"
            },
            {
              image: "/images/product/intermediate/3.png",
              name: "Ethyl chloro[(4-methoxyphenyl)hydrazono]acetat",
              casNo: "27143-07-3"
            },
            {
              image: "/images/product/intermediate/4.png",
              name: "5,6-Dihydro-3-(4-morpholinyl)-1-[4-(2-oxo-1-piperidinyl)phenyl]-2(1H)-pyridinone",
              casNo: "545445-44-1"
            }
          ]
        },
        {
          name: "Intermediate For Bilastine",
          products: [
            {
              image: "/images/product/intermediate/cas-202189-76-2.png",
              name: "2-[4-[1-(4,4-dimethyl-5H-oxazol-2yl)-1-methyl-ethyl]phenyl]ethyl 4-methylbenzenesulfonate",
              casNo: "202189-76-2"
            }
          ]
        },
        {
          name: "Intermediates for Brinzolamide",
          products: [
            {
              image: "/images/product/intermediate/6.png",
              name: "3-Acetyl-2,5-dichlorothiophene",
              casNo: "36157-40-1"
            },
            {
              image: "/images/product/intermediate/7.png",
              name: "3-Acetyl-5-chlorothiophene-2-sulfonamide",
              casNo: "160982-10-5"
            },
            {
              image: "/images/product/intermediate/8.png",
              name: "3-Bromoacetyl-5-chlorothiophene-2-sulphonamide",
              casNo: "160982-11-6"
            },
            {
              image: "/images/product/intermediate/9.png",
              name: "6-Chloro-3,4-dihydro-2H-thieno[3,2-e][1,2]thiazin-4-ol-1,1-dioxide",
              casNo: "171274-01-4"
            },
            {
              image: "/images/product/intermediate/10.png",
              name: "6-Chloro-3,4-dihydro-2H-thieno[3,2-e][1,2]thiazin-4-one-1,1-dioxide",
              casNo: "174139-69-6"
            },
            {
              image: "/images/product/intermediate/11.png",
              name: "3,4-Dihydro-2H-thieno[3,2-e][1,2]thiazin-4-ol-1,1-dioxide",
              casNo: "138890-97-8"
            },
            {
              image: "/images/product/intermediate/12.png",
              name: "3,4-Dihydro-2H-thieno[3,2-e][1,2]thiazin-4-one-1,1-dioxide",
              casNo: ""
            },
            {
              image: "/images/product/intermediate/13.png",
              name: "2-(3-Methoxypropyl)-3,4-dihydro-2H-thieno[3,2-e][1,2]thiazin-4-ol 1,1-dioxide",
              casNo: ""
            },
            {
              image: "/images/product/intermediate/14.png",
              name: "(4S)-4-Hydroxy-2-(3-methoxypropyl)-3,4-dihydro-2H-thieno[3,2-e][1,2]thiazine-6-sulfonamide-1,1-dioxide",
              casNo: "154127-42-1"
            }
          ]
        },
        {
          name: "Intermediate for Dasatinib",
          products: [
            {
              image: "/images/product/intermediate/15.png",
              name: "2-Amino-N-(2-chloro-6-methylphenyl)-1, 3-thiazole-5-carboxamide (172-A)",
              casNo: "302964-24-5"
            },
            {
              image: "/images/product/intermediate/16.png",
              name: "4,6-Dichloro-2-methylpyrimidine",
              casNo: "1780-26-3"
            }
          ]
        },
        {
          name: "Intermediates for Dorzolamide",
          products: [
            {
              image: "/images/product/intermediate/17.png",
              name: "5,6-Dihydro-6-methylthieno[2,3-b]thiopyran-4-one",
              casNo: "120279-85-8"
            },
            {
              image: "/images/product/intermediate/18.png",
              name: "5,6-Dihydro-6-methyl-4-oxothieno[2,3-b]thiopyran-2-sulphonamide",
              casNo: "120279-88-1"
            },
            {
              image: "/images/product/intermediate/19.png",
              name: "5,6-Dihydro-4-hydroxy-6-methyl4Hthieno[2,3b]thiopyran-2-sulphonamide-7,7-dioxide",
              casNo: "154802-22-9"
            },
            {
              image: "/images/product/intermediate/20.png",
              name: "5,6-Dihydro-6-methyl-4-oxothieno[2,3-b]thiopyran-2-sulphonamide-7,7-dioxide",
              casNo: ""
            },
            {
              image: "/images/product/intermediate/21.png",
              name: "N[6-Methyl-7,7-dioxide-2-sulfamoyl-5,6-dihydro-4H-thieno[2,3-b]thiopyran-4-yl]acetamide",
              casNo: "120298-38-6"
            },
            {
              image: "/images/product/intermediate/22.png",
              name: "5,6-Dihydro-(6S)-6-methylthieno[2,3-b]thiopyran-4-one",
              casNo: ""
            },
            {
              image: "/images/product/intermediate/23.png",
              name: "(6S)-6-methyl-5,6-dihydro-4H-thieno[2,3-b]thiopyran-4-one 7,7-dioxide",
              casNo: "148719-91-9"
            },
            {
              image: "/images/product/intermediate/24.png",
              name: "(4S,6S)-6-methyl-5,6-dihydro-4H-thieno[2,3-b]thiopyran-4-ol-7,7-dioxide",
              casNo: ""
            },
            {
              image: "/images/product/intermediate/25.png",
              name: "5,6-Dihydro-(6S)-6-methyl-4-oxothieno[2,3-b]thiopyran-2-sulfonamide",
              casNo: ""
            },
            {
              image: "/images/product/intermediate/26.png",
              name: "N-[(4S,6S)-6-methyl-7,7-dioxido-5,6-dihydro-4H-thieno[2,3-b]thiopyran-4-yl]acetamide",
              casNo: "147086-83-0"
            },
            {
              image: "/images/product/intermediate/27.png",
              name: "N-[(4S,6S)-6-Methyl-7,7-dioxido-2-sulfamoyl-5,6-dihydro -4H-thieno[2,3-b]thiopyran -4-yl] acetamide",
              casNo: "147200-03-1"
            }
          ]
        },
        {
          name: "Intermediate for Doxylamine",
          products: [
            {
              image: "/images/product/intermediate/28.png",
              name: "1-Methyl-1-phenyl-1-(2-pyridyl)methanol .HCl",
              casNo: "19478-81-0"
            }
          ]
        },
        {
          name: "Intermediates For Edoxaban",
          products: [
            {
              image: "/images/product/intermediate/cas-349125-08-2.png",
              name: "2-[(5-Chloropyridin-2yl)amino]-2-oxoacetic acid ethyl ester",
              casNo: "349125-08-2"
            },
            {
              image: "/images/product/intermediate/cas-720720-96-7.png",
              name: "5-Methyl-4,5,6,7-tetrahydrothiazolo[5,4-c]pyridine-2-carboxylic Acid Hydrochloride",
              casNo: "720720-96-7"
            }
          ]
        },
        {
          name: "Intermediates for Erlotinib",
          products: [
            {
              image: "/images/product/intermediate/31.png",
              name: "6,7-Dihydroxyquinazolin-4(3H)-one",
              casNo: "16064-15-6"
            },
            {
              image: "/images/product/intermediate/32.png",
              name: "6,7-bis(2-methoxyethoxy)quinazolin-4(3H)-one",
              casNo: "179688-29-0"
            },
            {
              image: "/images/product/intermediate/33.png",
              name: "4-Chloro-6,7-bis(2-methoxyethoxy) quinazoline",
              casNo: "183322-18-1"
            },
            {
              image: "/images/product/intermediate/34.png",
              name: "Methyl 2-amino-4,5-bis(2-methoxyethoxy)benzoate Hydrochloride",
              casNo: "179688-29-0"
            }
          ]
        },
        {
          name: "Intermediates for Ezetimibe",
          products: [
            {
              image: "/images/product/intermediate/35.png",
              name: "1-(4-Fluorophenyl)-5-(2-oxo-(4S)-4 phenyloxazolidin-3-yl) pentane-1,5-dione",
              casNo: "189028-93-1"
            },
            {
              image: "/images/product/intermediate/36.png",
              name: "3-[5-(4-Fluorophenyl)-(5S)-5-hydroxypentanoyl]-(4S)-4-phenyloxazolidin-2-one",
              casNo: "189028-95-3"
            },
            {
              image: "/images/product/intermediate/37.png",
              name: "Methyl(3R,4S)-1-(4-flurophenyl)-2-oxo-4-[4-benzyloxyphenyl]-3- azetidin-3-yl-propionate",
              casNo: "204589-80-0"
            },
            {
              image: "/images/product/intermediate/38.png",
              name: "(4S)-4-benzyl-3-[(5S)-5-(4-fluorophenyl)-5-hydroxypentanoyl]-1,3-oxazolidin-2-one",
              casNo: "852148-49-3"
            },
            {
              image: "/images/product/intermediate/39.png",
              name: "(3R,4S)1-(4-Fluorophenyl)-3-[(3S)-3-(4-fluorophenyl)-3-hydroxypropyl]-4-[4-benzyloxyphenyl] azetidin-2-one",
              casNo: "163222-32-0"
            },
            {
              image: "/images/product/intermediate/40.png",
              name: "(3[-{2{(S)(4-Benzyloxyphenyl)(4-fluorophenylamino)methyl}-5-(4-fluorophenyl)-(5S)-5-trimethylsilanoyloxypentanoyl]-(4S)-4-phenyl-1,3-oxazolidin-2-one",
              casNo: "1197343-07-9"
            },
            {
              image: "/images/product/intermediate/41.png",
              name: "(3R,4S)-1-(4-fluorophenyl)-3-[3-(4-fluorophenyl)-3-oxopropyl]-4-[4-(benzyloxy) phenyl] azetidin-2-one",
              casNo: "190595-65-4"
            },
            {
              image: "/images/product/intermediate/CAS-191330-56-0.png",
              name: "(3R,4S)-1-(4-fluorophenyl)-3-[3-(4-fluorophenyl)-3-oxopropyl]-4-(4- hydroxyphenyl)azetidin-2-one",
              casNo: "191330-56-0"
            }
          ]
        },
        {
          name: "Intermediates for Gefitinib",
          products: [
            {
              image: "/images/product/intermediate/42.png",
              name: "6-Hydroxy 7-methoxyquinazolin-4(3H)-one",
              casNo: "179688-52-9"
            },
            {
              image: "/images/product/intermediate/43.png",
              name: "4-Methoxy-5-[3-(morpholin-4-yl)propoxy]-2-nitrobenzonitrile",
              casNo: "675126-26-8"
            },
            {
              image: "/images/product/intermediate/44.png",
              name: "7-Methoxy-4-oxo-3,4-dihydroquinazolin-6-yl acetate",
              casNo: "179688-53-0"
            },
            {
              image: "/images/product/intermediate/CAS-199327-61-2.png",
              name: "7-Methoxy-6-[3-(morpholin -4-yl)propoxy] quinazolin-4(3H)-one",
              casNo: "199327-61-2"
            }
          ]
        },
        {
          name: "Intermediates for Linezolid",
          products: [
            {
              image: "/images/product/intermediate/49.png",
              name: "{(5R)-3-[3-Fluoro-4-(morpholin-4-yl)phenyl]-2-oxo-1,3-oxazolidin-5-yl}methyl methanesulfonate",
              casNo: "174649-09-3"
            },
            {
              image: "/images/product/intermediate/50.png",
              name: "(5R)-5-(Azidomethyl)-3-[3-fluoro-4-(morpholin-4-yl)phenyl]-1,3-oxazolidin-2-one",
              casNo: "168828-84-0"
            },
            {
              image: "/images/product/intermediate/CAS-168828-82-8.png",
              name: "(5R)-3-(3-Fluoro-4-(4-morpholinyl)phenyl)-5-hydroxymethyl-2-oxazolidione",
              casNo: "168828-82-8"
            },
            {
              image: "/images/product/intermediate/CAS-168828-90-8.png",
              name: "(5S)-5-(aminomethyl-3-(3-fluoro-4-morpholinophenyl)-1,3-oxazolidin-2one",
              casNo: "168828-90-8"
            }
          ]
        },
        {
          name: "Intermediate for Lornoxicam",
          products: [
            {
              image: "/images/product/intermediate/51.png",
              name: "Methyl 6-chloro-4-hydroxy-2-methyl-2Hthieno[2,3e][1,2]thiazine-3-carboxylate 1,1-dioxide",
              casNo: "70415-50-8"
            }
          ]
        },
        {
          name: "Intermediates for Rivaroxaban",
          products: [
            {
              image: "/images/product/intermediate/57.png",
              name: "5-Chlorothiophene-2-carboxylic acid",
              casNo: "24065-33-6"
            },
            {
              image: "/images/product/intermediate/CAS-438056-69-0.png",
              name: "4-(4-Aminophenyl)morpholin-3-one",
              casNo: "438056-69-0"
            },
            {
              image: "/images/product/intermediate/CAS-42518-98-9.png",
              name: "5- Chlorothiophene-2-carbonyl chloride",
              casNo: "42518-98-9"
            }
          ]
        },
        {
          name: "Intermediate for Sertaconzole",
          products: [
            {
              image: "/images/product/intermediate/59.png",
              name: "3-(Bromomethyl)-7-Chlorobenzo[b]Thiophen",
              casNo: "17512-61-7"
            }
          ]
        },
        {
          name: "Intermediates for Sorafenib",
          products: [
            {
              image: "/images/product/intermediate/60.png",
              name: "4-chloro-N-methylpyridine-2-carboxamide",
              casNo: "220000-87-3"
            },
            {
              image: "/images/product/intermediate/61.png",
              name: "4-(4-aminophenoxy)-N-methylpyridine-2-carboxamide",
              casNo: "284462-37-9"
            },
            {
              image: "/images/product/intermediate/62.png",
              name: "1-[4-chloro-3-(trifluoromethyl)phenyl]-3-(4-hydroxyphenyl)urea",
              casNo: ""
            }
          ]
        },
        {
          name: "Intermediates for Sunitinib",
          products: [
            {
              image: "/images/product/intermediate/63.png",
              name: "5-formyl-2,4-dimethyl,1H-pyrrole-3-carboxylic acid",
              casNo: "253870-02-9"
            },
            {
              image: "/images/product/intermediate/64.png",
              name: "5-fluoro-2-oxiindole",
              casNo: "56341-41-4"
            }
          ]
        },
        {
          name: "Intermediates for Suxamethonium",
          products: [
            {
              image: "/images/product/intermediate/CAS-6101-15-1.png",
              name: "N,N'-(Succinyldioxydiethylene)Bis(Trimethylammonium)-Dichloride-Dihydrate.",
              casNo: "6101-15-1"
            },
            {
              image: "/images/product/intermediate/CAS-53595-66-7.png",
              name: "5-Chlorothiophene-2-yl sulfonamide",
              casNo: "53595-66-7"
            },
            {
              image: "/images/product/intermediate/CAS-859199-06-7.png",
              name: "2-Acetyl-5-bromo-4-methylthiophene",
              casNo: "859199-06-7"
            }
          ]
        },
        {
          name: "Intermediate for Tiagabine",
          products: [
            {
              image: "/images/product/intermediate/65.png",
              name: "4-Bromo-1,1-bis(3-methyl-2-thienyl)-1-butene",
              casNo: "109857-81-0"
            }
          ]
        },
        {
          name: "Intermediate for Tioconazole",
          products: [
            {
              image: "/images/product/intermediate/66.png",
              name: "2-Chloro-3-methylthiophene",
              casNo: "14345-97-2"
            }
          ]
        },
        {
          name: "Intermediate for Tiotropium Bromide",
          products: [
            {
              image: "/images/product/intermediate/CAS-26447-85-8.png",
              name: "methyl-2-hydroxy-2,2-(dithiophen-2-yl)acetate",
              casNo: "26447-85-8"
            }
          ]
        },
        {
          name: "Intermediate for Zileuton",
          products: [
            {
              image: "/images/product/intermediate/67.png",
              name: "1-(1-Benzothiophen-2-yl)ethanone",
              casNo: "22720-75-8"
            }
          ]
        }
      ]
    },
    {
      id: "pyridine",
      label: "Pyridine Derivatives",
      groups: [
        {
          name: "Pyridine derivatives",
          products: [
            {
              image: "/images/product/pyridine/1.png",
              name: "2-Benzoylpyridine",
              casNo: "91-02-1"
            },
            {
              image: "/images/product/pyridine/2.png",
              name: "2-Benzylpyridine",
              casNo: "101-82-6"
            },
            {
              image: "/images/product/pyridine/3.png",
              name: "4-Benzoylpyridine",
              casNo: "14548-46-0"
            },
            {
              image: "/images/product/pyridine/4.png",
              name: "4-Benzylpyridine",
              casNo: "2116-65-6"
            }
          ]
        }
      ]
    },
    {
      id: "thiophene",
      label: "Thiophene Derivatives",
      groups: [
        {
          name: "Thiophene derivatives",
          products: [
            {
              image: "/images/product/thiophene/3.png",
              name: "2-Chlorothiophene",
              casNo: "96-43-5"
            },
            {
              image: "/images/product/thiophene/4.png",
              name: "3-Chlorothiophene",
              casNo: "17249-80-8"
            },
            {
              image: "/images/product/thiophene/5.png",
              name: "2-Bromothiophene",
              casNo: "1003-09-4"
            },
            {
              image: "/images/product/thiophene/8.png",
              name: "Ethyl-5-chlorothiophene-2-yl sulfonyl carbamate",
              casNo: "849793-87-9"
            },
            {
              image: "/images/product/thiophene/11.png",
              name: "5-Bromothiophene-2-carboxylic acid",
              casNo: "7311-63-9"
            },
            {
              image: "/images/product/thiophene/12.png",
              name: "5-Formylthiophene-2-carboxylic acid",
              casNo: "4565-31-5"
            },
            {
              image: "/images/product/thiophene/14.png",
              name: "2,5-dichlorothiophene-3-carboxylic acid",
              casNo: "36157-41-2"
            },
            {
              image: "/images/product/thiophene/16.png",
              name: "2-Acetylthiophene",
              casNo: "14345-97-2"
            },
            {
              image: "/images/product/thiophene/17.png",
              name: "2-Chloro-3- methylthiophene",
              casNo: "14282-76-9"
            },
            {
              image: "/images/product/thiophene/18.png",
              name: "2-Bromo-3- methylthiophene",
              casNo: "4701-17-1"
            }
          ]
        }
      ]
    }
  ]
};
